<div [class.container]="!section['fullWidth']">
<!--Optional section header-->

  <div class="row" *ngIf="section['header']">

      <div class="col-sm-12" >

          <customer-site-column-text *ngIf="section['header'].type === 'text'">

              <div class="customer-site-column-text-content" [innerHTML]="section['header'].html | safe: 'html'"></div>

          </customer-site-column-text>

      </div>

  </div>


  <!-- sections -->

  <div class="row" *ngIf="columnCount > 0">

    <!--Create columns based on the number of items in columns array-->
    <ng-container *ngFor="let column of section['columns']; let columnIndex = index">
        <div class="col-xs-12"
            *ngIf="column.type"
            [class.col-sm-6]="columnCount === 2"
            [class.col-sm-4]="columnCount === 3">
            <customer-site-column [column]="column" [theme]="theme" ></customer-site-column>
        </div>
    </ng-container>

  </div>
</div>
